import { SettingBookings } from "features/Setting/ui/SettingBookings"

export const SettingBookingsPages = () => {
    return (
        <SettingBookings />
    )
}